module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Shopping cart"},"fr":{"title":"Panier d\u0027achat"}}')
  delete Component.options._Ctor
}
